import dot from "refractor/dot";
export default dot;